<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '合同归档申请', path:'/item'}"></Title>

    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">合同信息</el-divider>

        <el-form-item label="所属项目" prop="projectId">
          <el-select style="width: 500px" v-model="ruleForm.projectId" placeholder="请选择所属项目" filterable>
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :disabled="item.projectState === 6"
              :value="item.projectId">
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
              <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
              <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="合同名" prop="contractName">
          <el-input v-model="ruleForm.contractName"></el-input>
        </el-form-item>

        <el-form-item label="合同类型" prop="contractType" required>
          <el-radio-group v-model="ruleForm.contractType" @input="changeRadio">
            <el-radio label="1">销售合同</el-radio>
            <el-radio label="2">渠道合同</el-radio>
            <el-radio label="3">框架协议</el-radio>
            <el-radio label="4">采购合同</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="合同签署" prop="contractSign" required>
          <el-radio-group v-model="ruleForm.contractSign" @input="changeRadio">
            <el-radio label="1">御码网控</el-radio>
            <el-radio label="2">中科安永</el-radio>
            <el-radio label="3">贵州数安达</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="ruleForm.contractType === 1">

        </div>
        <el-form-item label="合同金额" prop="contractAmount">
          <el-input v-model="ruleForm.contractAmount" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="合同方" prop="contractAmount">
          <el-button-group>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addDomain">新增</el-button>
            <el-button type="primary" icon="el-icon-remove-outline" @click="ruleForm.domain.pop()">删除</el-button>
          </el-button-group>
        </el-form-item>

        <el-form-item
          v-for="(item, index) in ruleForm.domain"
          :label="domainText[index] + '方'"
          :key="index"
        >
          <el-form-item
            style="margin-bottom: 18px"
            :prop="'domain.' + index + '.name'"
            :rules="{
              required: true, message: '合同方不能为空', trigger: 'blur'
            }">
            <el-input v-model="item.name" placeholder="合同方名称"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 18px">
            <el-input v-model="item.contact" placeholder="合同方联系方式"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 18px">
            <el-input v-model="item.remark" placeholder="其他"></el-input>
          </el-form-item>
        </el-form-item>

        <el-form-item label="合同签署时间" prop="contractSignTime">
          <el-date-picker
              v-model="ruleForm.contractSignTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="请选择合同签署时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="合同文件" required>
          <el-upload
            class="upload-demo"
            drag
            action=""
            :multiple=false
            :limit="1"
            :on-exceed="handleExceed"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .ofd, .zip, .rar"
            :on-change="handleFileChange"
            :file-list="fileList"
            :http-request="uploadSectionFile"
            :before-upload="beforeUpload"
            list-type="picture">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传word/pdf/ofd/jpg/png/jpeg/zip/rar文件，且不超过60M</div>
          </el-upload>
          <el-alert
            title="pdf文件现已支持在线预览"
            type="info">
          </el-alert>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="ruleForm.remarks"></el-input>
        </el-form-item>

        <el-Form-item>
          <el-button  v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>

      </el-form>

    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "@/util";
import {requestAllProject, requestContractApply, requestApplyDetail} from "@/api";

export default {
  components: {Title},
  name: "ContractApply",
  data() {
    return {
      submitShow: true,
      projectList: [],
      fileList: [],
      applyServiceId: "",
      applyType: "",
      applyId: null,
      contractId: null,
      reapply: false,
      domainText: ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'],
      ruleForm: {
        contractName: "",
        contractType: "1",
        contractSign: "1",
        projectId: "",
        signCompany: "",
        contractSignTime: "",
        contractFile: "",
        remarks: "",
        contractAmount: "",
        domain: [
          {
            name: "",
            contact: "",
            remark: ""
          },
          {
            name: "",
            contact: "",
            remark: ""
          }
        ]
      },
      rules: {
        contractName: [
          {required: true, message: '请输入合同名称', trigger: 'blur'},
          {max: 100, message: '长度最大100个字符', trigger: 'blur'}
        ],
        projectId: [
          {required: true, message: '请选择所属项目', trigger: 'blur'},
        ],
        signCompany: [
          {required: true, message: '请输入合同签署单位', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        contractSignTime: [
          {required: true, message: '请选择合同签署时间', trigger: 'blur'},
        ],
        contractFile: [
          {required: true, message: '请上传合同文件', trigger: 'blur'},
        ],
        contractAmount: [
          {required: true, validator: this.validatePrice, trigger: 'blur'}
        ]
      },
    }
  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.contractAmount)
    },
  },
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
  },
  methods: {

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData()
          formData.append("contractName", this.ruleForm.contractName)
          formData.append("contractType", this.ruleForm.contractType)
          formData.append("contractSign", this.ruleForm.contractSign)
          // json 存储合同方信息
          formData.append("signCompany", JSON.stringify(this.ruleForm.domain))
          formData.append("contractSignTime", this.ruleForm.contractSignTime)
          formData.append("remarks", this.ruleForm.remarks)
          formData.append("contractAmount", this.ruleForm.contractAmount)
          if (!this.ruleForm.contractAmount || this.ruleForm.contractAmount === 0) {
            // 合同金额为零 默认回款完成
            formData.append("paybackProcess", "2")
          }
          // 重新申请需要的参数
          if (this.reapply) {
            formData.append("contractId", this.contractId)
            formData.append("applyId", this.applyId)
            formData.append("reapply", this.reapply)
          }

          formData.append("projectId", this.ruleForm.projectId)


          if (this.fileList && this.fileList.length > 0) {
            formData.append("file", this.fileList[0].raw)
            const size = 1024 * 1024 * 20
            if (this.fileList[0].size > size) {
              this.$message.error("文件大小不能超过20MB")
              return
            }
          } else if (!this.reapply) {
            this.$message.error("请上传合同文件")
            return
          }
          this.submitShow = false
          requestContractApply(formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('ruleForm')
              this.ruleForm.domain = []
              this.fileList = []
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            //this.projectList.concat(
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.contractId = detail.contractId
            this.ruleForm.contractName = detail.contractName
            this.ruleForm.contractAmount = detail.contractAmount
            this.ruleForm.contractType = detail.contractType.toString()
            this.ruleForm.contractSign = detail.contractSign.toString()
            this.ruleForm.contractSignTime = detail.contractSignTime
            this.ruleForm.domain = JSON.parse(detail.signCompany)
            this.ruleForm.projectId = detail.projectId
            this.ruleForm.remarks = detail.remarks
            const file = {
              name: detail.fileName,
              url: require('@/assets/word.png')
            }
            this.fileList.push(file)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    beforeUpload(file) {
      const limitFlag = file.size / 1024 / 1024 > 60;
      if (limitFlag) {
        this.$message.error("文件大小过大")
        return false
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* beforeUpload(file) {

    },*/
    handleExceed(files, fileList) {
      this.$message.warning('只能上传1个文件')
    },
    // 上传文件
    uploadSectionFile(file) {

    },
    // 文件修改
    handleFileChange(file, fileList) {
      this.fileChange = true
      file.url = require('@/assets/word.png')
      console.log(file)
      this.fileList.push(file)
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileChange = true
      this.fileList = []
    },
    // 预览
    handlePreview(file) {
      console.log(file);
    },
    addDomain() {
      if (this.ruleForm.domain.length >= this.domainText.length) {
        return
      }
      this.ruleForm.domain.push({
        name: "",
        contact: "",
        remark: ""
      })
    },
    validatePrice(rule, value, callback) {
      value = value.toString()
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.projectAmountExpect = value
        callback();
      }
    },
    changeRadio(e) {
      if (e !== "1") {
        delete(this.rules.contractAmount)
      } else {
        this.rules.contractAmount = [
          {required: true, validator: this.validatePrice, trigger: 'blur'}
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>
